import { typedAction } from "../helpers";
import { ModeState } from "../models/reduxModels";
import { SET_MODE } from "./actionTypes";
import { ModeEnum } from "../../components/enums/modeEnum";

const initialState: ModeState = { mode: ModeEnum.mailCompose };

export const setMode = (mode: ModeEnum) => {
  return typedAction(SET_MODE, mode);
};

type ModeAction = ReturnType<typeof setMode>;

export function modeReducer(state = initialState, action: ModeAction): ModeState {
  switch (action.type) {
    case SET_MODE:
      return { mode: action.payload };
    default:
      return state;
  }
}
